import React from "react";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import { core, store } from "../../state";
import { SUPPORTED_LANGUAGE } from "../../content";
import { FlagContainer, FlagSelect } from "./LanguageSelector.style";

type Props = {
  languageList: string[];
};

const LanguageSelector: React.FC<Props> = (props) => {
  const onSelectChange = (
    event: React.ChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>,
  ) => {
    core.setUserLanguage(event.target.value as typeof SUPPORTED_LANGUAGE[number]);
  };

  return (
    <FormControl className="language-selector-form">
      <FlagSelect
        className="language-selector-select"
        labelId="language-selector"
        label="Language"
        defaultValue={store.lang}
        onChange={onSelectChange}
      >
        {props.languageList.map((lang) => (
          <MenuItem className="language-selector-item" key={lang} value={lang}>
            <FlagContainer
              className="language-selector-flag-container"
              bg={"./assets/icons/flags/" + `${lang}` + ".svg"}
            ></FlagContainer>
          </MenuItem>
        ))}
      </FlagSelect>
    </FormControl>
  );
};

export default LanguageSelector;
